import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

const OrderItemsTable = ({ items }) => {
    const { t } = useTranslation();
    const fallbackImage = "/assets/icons/korres-shares-logo.png";
    const hasItems = Array.isArray(items) && items.length > 0;

    return (
        <div className="mt-10">
            <p className="text-sm font-semibold text-slate-900">{t("GIFT_ORDER_ITEMS_TITLE")}</p>

            <div className="mt-4 hidden divide-y divide-slate-200 border-b border-slate-200 md:block">
                {hasItems ? (
                    items.map((item) => (
                        <div
                            key={item.id}
                            className="grid grid-cols-[64px_2.2fr_0.9fr_0.6fr_0.8fr] items-stretch gap-4 py-4"
                        >
                            <div className="flex items-center">
                                <img
                                    src={item.image || fallbackImage}
                                    alt=""
                                    onError={(event) => {
                                        event.currentTarget.onerror = null;
                                        event.currentTarget.src = fallbackImage;
                                    }}
                                    className="h-12 w-12 rounded-xl border border-slate-200 bg-white object-contain"
                                />
                            </div>
                            <div className="flex flex-col justify-center border-r border-slate-200">
                                <p className="text-sm font-semibold text-slate-900">{item.name}</p>
                                {item.link ? (
                                    <a href={item.link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs text-primary underline underline-offset-4 hover:opacity-75">
                                        {t("COMMON_SEE_ONLINE")}
                                        <ArrowRight className="h-3 w-3" />
                                    </a>
                                ) : (
                                    <span className="inline-flex items-center gap-1 text-xs text-primary underline underline-offset-4">
                                        {t("COMMON_SEE_ONLINE")}
                                        <ArrowRight className="h-3 w-3" />
                                    </span>
                                )}
                            </div>
                            <div className="flex flex-col items-center justify-center gap-0.5 border-r border-slate-200">
                                <p className="text-[11px] text-slate-400">{t("COMMON_CODE")}</p>
                                <p className="text-xs text-slate-600">{item.code}</p>
                            </div>
                            <div className="flex flex-col items-center justify-center gap-0.5 border-r border-slate-200">
                                <p className="text-[11px] text-slate-400">{t("COMMON_QTY")}</p>
                                <p className="text-xs text-slate-600">{item.qty}</p>
                            </div>
                            <div className="flex flex-col items-center justify-center gap-0.5">
                                <p className="text-[11px] text-slate-400">{t("COMMON_GIFT_VALUE")}</p>
                                <p className="text-xs font-semibold text-slate-700">{item.price}</p>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="py-6 text-sm text-slate-500">
                        {t("GIFT_ORDER_ITEMS_EMPTY")}
                    </div>
                )}
            </div>

            <div className="mt-4 space-y-3 md:hidden">
                {hasItems ? (
                    items.map((item) => (
                        <div
                            key={item.id}
                            className="rounded-2xl border border-slate-200 bg-white px-4 py-4 shadow-[0_10px_20px_rgba(15,23,42,0.04)]"
                        >
                            <div className="flex items-start gap-3">
                                <img
                                    src={item.image || fallbackImage}
                                    alt=""
                                    onError={(event) => {
                                        event.currentTarget.onerror = null;
                                        event.currentTarget.src = fallbackImage;
                                    }}
                                    className="h-12 w-12 rounded-xl border border-slate-200 bg-white object-contain"
                                />
                                <div className="flex-1">
                                    <p className="text-sm font-semibold text-slate-900">{item.name}</p>
                                    {item.link ? (
                                        <a href={item.link} target="_blank" rel="noreferrer" className="text-xs text-primary underline underline-offset-4 hover:opacity-75">
                                            {t("COMMON_SEE_ONLINE")}
                                        </a>
                                    ) : (
                                        <span className="text-xs text-primary underline underline-offset-4">
                                            {t("COMMON_SEE_ONLINE")}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="mt-4 grid grid-cols-3 gap-4 text-xs text-slate-500">
                                <div>
                                    <p className="text-[11px] text-slate-400">{t("COMMON_CODE")}</p>
                                    <p>{item.code}</p>
                                </div>
                                <div>
                                    <p className="text-[11px] text-slate-400">{t("COMMON_QTY")}</p>
                                    <p>{item.qty}</p>
                                </div>
                                <div>
                                    <p className="text-[11px] text-slate-400">{t("COMMON_GIFT_VALUE")}</p>
                                    <p className="text-xs font-semibold text-slate-700">{item.price}</p>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="rounded-2xl border border-slate-200 bg-white px-4 py-6 text-sm text-slate-500 shadow-[0_10px_20px_rgba(15,23,42,0.04)]">
                        {t("GIFT_ORDER_ITEMS_EMPTY")}
                    </div>
                )}
            </div>
        </div>
    );
};

export default OrderItemsTable;
